function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.973 2.99194H3.01446C2.87514 2.99194 2.76221 3.10174 2.76221 3.23718V5.22355C2.76221 5.35899 2.87514 5.46878 3.01446 5.46878H10.973C11.1123 5.46878 11.2253 5.35899 11.2253 5.22355V3.23718C11.2253 3.10174 11.1123 2.99194 10.973 2.99194Z",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.973 7.43042H3.01446C2.87514 7.43042 2.76221 7.54021 2.76221 7.67565V14.9345C2.76221 15.0699 2.87514 15.1797 3.01446 15.1797H10.973C11.1123 15.1797 11.2253 15.0699 11.2253 14.9345V7.67565C11.2253 7.54021 11.1123 7.43042 10.973 7.43042Z",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3856 0.613037H1.6144C1.07107 0.613037 0.630615 1.04123 0.630615 1.56944V16.4305C0.630615 16.9587 1.07107 17.3869 1.6144 17.3869H12.3856C12.9289 17.3869 13.3694 16.9587 13.3694 16.4305V1.56944C13.3694 1.04123 12.9289 0.613037 12.3856 0.613037Z",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5874 7.43042V15.1797",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2379 10.0178H2.76221",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41266 12.5925H2.76221",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.4126 7.43042V15.1797",
  stroke: "#3C445A",
  strokeMiterlimit: 10
});

var SvgCalculator = function SvgCalculator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculator.9942087c.svg";
export { ForwardRef as ReactComponent };